module.exports = __webpack_public_path__ + "img/1753839529213-WhatsApp Image 2025-07-30 at 09.29.49.jpeg.f9635f9f.webp";